import { FORM_NAMES } from "constants/index"
import React, { useEffect, useState } from "react"
import { Nav, NavLink, TabContent, TabPane } from "reactstrap"
import { FormSection, reduxForm } from "redux-form"
import { DEFAULT_TAB, FIRST_TAB, LAST_TAB, TABS } from "./constants"
import LoadingScreenSetup from "./loading-screen-setup"
import SignUpLoginScreens from "./signUp-login-screens"

const Wizard = ({ handleSave, setBreadcrumbItems }) => {
  const [activeTab, setActiveTab] = useState(DEFAULT_TAB)

  const handleNext = () => {
    if (activeTab !== LAST_TAB) {
      setActiveTab(activeTab + 1)
    }
  }

  const handleBack = () => {
    if (activeTab !== FIRST_TAB) {
      setActiveTab(activeTab - 1)
    }
  }

  const markIfIsActive = tab => {
    return activeTab === tab ? "active" : ""
  }

  const setSubTabBreadcrumb = (tabTitle, clickHandler) => {
    setBreadcrumbItems([
      { title: "Dashboard" },
      {
        title: "Onboarding Flow",
        type: "tab",
        clickHandler: () => setActiveTab(DEFAULT_TAB),
      },
      {
        title: activeTab === 1 ? "Landing Screen" : "Sign Up & Login Screens",
        type: "tab",
        clickHandler: clickHandler,
      },
      { title: tabTitle },
    ])
  }

  return (
    <form onSubmit={handleSave}>
      <Nav pills tabs>
        <NavLink
          className={markIfIsActive(TABS.LOADING_SCREEN)}
          onClick={() => setActiveTab(TABS.LOADING_SCREEN)}
        >
          {<span style={{ fontSize: "16px" }}>Loading Screen</span>}
        </NavLink>
        <NavLink
          className={markIfIsActive(TABS.SIGNUP_LOGIN)}
          onClick={() => setActiveTab(TABS.SIGNUP_LOGIN)}
        >
          {<span style={{ fontSize: "16px" }}>Sign Up/Login Screens</span>}
        </NavLink>
      </Nav>
      <TabContent activeTab={activeTab}>
        <TabPane tabId={TABS.LOADING_SCREEN}>
          <FormSection name="loadingScreen">
            <LoadingScreenSetup
              isActive={activeTab === TABS.LOADING_SCREEN}
              handleBack={activeTab !== FIRST_TAB ? handleBack : null}
              handleNext={activeTab !== LAST_TAB ? handleNext : null}
              handleSave={handleSave}
              setSubTabBreadcrumb={setSubTabBreadcrumb}
            />
          </FormSection>
        </TabPane>
        <TabPane tabId={TABS.SIGNUP_LOGIN}>
          <SignUpLoginScreens
            isActive={activeTab === TABS.SIGNUP_LOGIN}
            handleBack={activeTab !== FIRST_TAB ? handleBack : null}
            handleNext={activeTab !== LAST_TAB ? handleNext : null}
            handleSave={handleSave}
            setSubTabBreadcrumb={setSubTabBreadcrumb}
          />
        </TabPane>
      </TabContent>
    </form>
  )
}

export default reduxForm({
  form: FORM_NAMES.ONBOARDING_FLOW_WIZARD,
})(Wizard)
